<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 14:21:22
 * @Description: 合作伙伴
 -->

<template>
  <div class="m-partner-wrapper">
    <a href="https://www.aliyun.com/">
      <img src="https://files.jinr.com/jinr-index/img/partner-01.jpg" alt="" srcset="" />
    </a>
    <a href="https://www.cunnar.com/">
      <img src="https://files.jinr.com/jinr-index/img/partner-02.jpg" alt="" srcset="" />
    </a>
    <a href="https://www.yeepay.com/">
      <img src="https://files.jinr.com/jinr-index/img/partner-03.jpg" alt="" srcset="" />
    </a>
    <a href="https://www.fadada.com">
      <img src="https://files.jinr.com/jinr-index/img/partner-04.png" alt="" srcset="" />
    </a>
    <a href="http://www.geotmt.com/">
      <img src="https://files.jinr.com/jinr-index/img/partner-05.png" alt="" srcset="" />
    </a>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.m-partner-wrapper {
  display: flex;
  padding: 0.4rem;
  flex-wrap: wrap;
  justify-content: space-between;
  a {
    width: 2.1rem;
    height: 1.3rem;
    margin: 0.2rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
